import React from 'react';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';

export const ContentFirstHeader = ({ previous, onClose }: Props) => {

    return (
        <WindowHeader hidePrevious={true} previous={previous ?? onClose} onClose={onClose}>
            {" "}
        </WindowHeader>
    );
};

type Props = {
    previous?: () => void;
    onClose: () => void;
};